export const formatDate = (inputDate: Date) => {
	const todayDate = new Date(Date.now());
	const postedDate = new Date(inputDate);

	const todayMonth = todayDate.getMonth(),
		todayYear = todayDate.getFullYear(),
		todayDay = todayDate.getDate(),
		todayHours = todayDate.getHours(),
		todayMinutes = todayDate.getMinutes(),
		todaySeconds = todayDate.getSeconds();

	const postedMonth = postedDate.getMonth(),
		postedYear = postedDate.getFullYear(),
		postedDay = postedDate.getDate(),
		postedHours = postedDate.getHours(),
		postedMinutes = postedDate.getMinutes(),
		postedSeconds = postedDate.getSeconds();

	if (
		todayDay === postedDay &&
		todayMonth === postedMonth &&
		todayYear === postedYear
	) {
		if (todayHours !== postedHours) {
			return `Postado há ${todayHours - postedHours} hora${
				todayHours - postedHours > 1 ? "s" : ""
			}`;
		} else if (todayMinutes !== postedMinutes) {
			return `Postado há ${todayMinutes - postedMinutes} minuto${
				todayMinutes - postedMinutes > 1 ? "s" : ""
			}`;
		} else {
			return `Postado há ${todaySeconds - postedSeconds} second${
				todaySeconds - postedSeconds > 1 ? "s" : ""
			}`;
		}
	} else if (todayDay - postedDay === 1) {
		return `Postado ontem`;
	} else {
		const monthName = postedDate.toLocaleString("pt-BR", { month: "long" });
		return `Postado dia ${postedDay} de ${monthName} de ${postedYear}`;
	}
};
